import { useState } from "react"

interface StarT {
    stars: number;
    onSelectedChange: Function;
}

export default function Star({ stars, onSelectedChange }: StarT) {
    const sArr = Array(stars).fill(0);
    const [selectedVal, setSelectedVal] = useState(0);
    const [mOverVal, setMOverVal] = useState(0);

    const handleMOver = (i: number) => {
        setMOverVal(i);
    }

    const handleMLeave = () => {
        setMOverVal(0);
    }

    const handleClicked = (i: number) => {
        setSelectedVal(i);
        onSelectedChange(i);
    }

    return (
        <div className="form-rating__stars">
            <ul className="form-rating__list">
                {sArr.map((s, i) => (
                    <li key={i} className="form-rating__item">
                        <div
                            className={`${(selectedVal || mOverVal) > i ? 'star-full' : 'star-empty'}`}
                            onClick={() => handleClicked(i + 1)}
                            onMouseOver={() => handleMOver(i + 1)}
                            onMouseLeave={handleMLeave}
                        ></div>
                    </li>
                ))}

            </ul>
        </div>
    )
}